<template>

  <div class="row mb-5">
    <div class="col-12 col-lg-8 offset-lg-2">
      <div class="formular-box">
        <div class="row">
          <div class="col-12 text-center">
            <div class="alert" :class="[(error === true) ? 'alert-danger' : 'alert-info']">
              <i v-if="(error === true)" class="fa fa-2x fa-exclamation-triangle" aria-hidden="true"></i>
              <h2 class="mt-0 pt-0 mb-0 pt-2 pb-4">{{ head }}</h2>
              <p style="font-weight: normal" class="lead">{{ body }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>

import General from '@/mixins/general';

export default {
  mixins: [General],
  components: {},
  props: {
    title: {
      Type: String,
      default: 'Vielen Dank für Ihre kostenlose Anfrage!'
    },
    text: {
      Type: String,
      default: 'Ihr Auftrag wurde versandt.'
    },
    titleSuccess: {
      Type: String,
      default: 'Vielen Dank für Ihre kostenlose Anfrage!'
    },
    textSuccess: {
      Type: String,
      default: 'Wir haben Ihre Anfrage erhalten und melden uns zeitnah bei Ihnen.'
    },
    titleError: {
      Type: String,
      default: 'Es tut uns leid!'
    },
    textError: {
      Type: String,
      default: 'Da ist etwas schief gelaufen, bitte versuchen Sie es in 5 Minuten erneut.'
    },
    error: {
      Type: Boolean,
      required: true
    }
  },
  data() {
    return {
      head: this.title,
      body: this.text,
    }
  },
  watch: {
    error: function (newVal) {
      if (newVal === true) {
        this.head = this.titleError;
        this.body = this.textError;
      } else if (newVal === false) {
        this.head = this.titleSuccess;
        this.body = this.textSuccess;
      } else {
        this.head = this.title;
        this.body = this.text;
      }
    }
  }
}
</script>
